import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 使用vue3 UI 库
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

createApp(App)
.use(ElementPlus).use(store).use(router).mount('#app')
